var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "42px",
    viewBox: "0 0 36 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-key") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-625.000000, -2057.000000)",
    fill: "#5BAF5A",
    fillRule: "nonzero",
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.000000, 1822.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-4",
    transform: "translate(440.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7267857,51.4534441 L38.7955357,59.5456766 L42.5080357,63.4030288 C43.3276786,64.1744993 43.3276786,65.4219834 42.5080357,66.1195896 C41.825,66.9567171 40.6035714,66.9567171 39.8482143,66.1195896 L36.0714286,62.3278945 L33.6558929,64.7982413 L37.3651786,68.6555936 C38.1848214,69.427064 38.1848214,70.6745481 37.3651786,71.3721544 C36.6821429,72.2092819 35.4607143,72.2092819 34.7077679,71.3721544 L29.5648304,66.1195896 C28.8117232,65.4219834 28.8117232,64.1744993 29.5648304,63.4030288 L43.9946429,48.6630191 C42.6526786,46.7343429 41.8571429,44.3706888 41.8571429,41.8182706 C41.8571429,35.2911383 47.0401786,30 53.4285714,30 C59.8169643,30 65,35.2911383 65,41.8182706 C65,48.3429409 59.8169643,53.6365413 53.4285714,53.6365413 C50.9294643,53.6365413 48.6151786,52.8240352 46.7267857,51.4534441 Z M53.4285714,49.6971177 C57.6875,49.6971177 61.1428571,46.1680508 61.1428571,41.8182706 C61.1428571,37.466849 57.6875,33.9394235 53.4285714,33.9394235 C49.0973214,33.9394235 45.7142857,37.466849 45.7142857,41.8182706 C45.7142857,46.1680508 49.0973214,49.6971177 53.4285714,49.6971177 Z",
    id: "icon-key"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.1011fd4657191faf2deab7c5b3415804.svg";
export { ForwardRef as ReactComponent };